import $ from 'jquery';

import widgetFactory from '../widgetFactory';

const widgetName = 'codeBlock';

const widget = widgetFactory(widgetName, {
  options: {
    source: '',
    language: 'text',
  },

  _create: function () {
    this._super(widgetName);
    this._initCodeCopyFeature();
    this._attachEvents();
  },

  _attachEvents: function () {
    var showRawClass = 'code-block--show-raw-code';

    this.elements.$container
      .on(
        'click',
        'code',
        function () {
          this.elements.$container
            .toggleClass(showRawClass)
            .find('textarea')
            .val(this.getCode())
            .select();
        }.bind(this)
      )
      .on(
        'blur',
        'textarea',
        function () {
          this.elements.$container.toggleClass(showRawClass);
        }.bind(this)
      );
  },

  _initCodeCopyFeature: function () {
    var $textarea = $('<textarea>');

    this.elements.$container = this.element.parent();

    if (!this.elements.$container.is('pre')) {
      this.elements.$container = this.element.wrap('<pre>').parent();
    }

    $textarea.addClass('code-block--raw-code').insertAfter(this.element);

    this.elements.$container.addClass('code-block');
  },

  getCode: function () {
    return this.options.source;
  },

  getLanguage: function () {
    return this.options.language;
  },
});

export default widget;
